import script from "./BaoPinData.vue?vue&type=script&lang=ts&setup=true"
export * from "./BaoPinData.vue?vue&type=script&lang=ts&setup=true"

import "./BaoPinData.vue?vue&type=style&index=0&id=4237944e&lang=stylus&scoped=true"

import exportComponent from "/www/wwwroot/home/v-admin/node_modules/.store/vue-loader@16.8.3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4237944e"]])

export default __exports__